
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts",
      function () {
        return require("private-next-pages/gifts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts"])
      });
    }
  